import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import {
  LucidiumProvider,
  Loading,
  PageHeader,
  HeadTitle
} from '@lucidhq/lucidium';
import axios from 'axios';
import * as pages from './pages';

axios.defaults.baseURL = process.env.REACT_APP_SIX_API_ENDPOINT;

export const App = () => (
  <BrowserRouter>
    <HeadTitle title="Opinion Survey" />
    <LucidiumProvider>
      <PageHeader
        title="Opinion Survey"
        lss={{
          bg: 'primary',
          color: 'primaryText',
          padding: '5px 5px 10px 10px'
        }}
      />
      <React.Suspense fallback={<Loading />}>
        <Switch>
          <Route
            path="/:projectUUID/:marketplaceSurveyId"
            component={pages.Home}
          />
        </Switch>
      </React.Suspense>
    </LucidiumProvider>
  </BrowserRouter>
);
